

var Collection = require('js/lib/collection');
var Searches = require('js/collections/searches');
var Activity = require('js/models/activity');
var config = require('js/config');

/**
 * Activities
 * @exports Activities
 * @constructor
 * @alias module:collections/activities
 */
var Activities = Searches.extend({
  url: config.build.apiPath + '/api/activity',
  accumulate: true,
  paginationType: Collection.PAGINATION_TYPES.PAGE_NUMBER,
  model: Activity,
});

Activities.prototype.parse = function(response, options) {
  // Ensure data cache
  this.ensureDataCache(response, this.dataCacheMap, options.accumulate);

  if (response.notifications) {
    this.total = response.notifications.length;
    return this.parseCollection(response.notifications, options);
  }

  const result = response.result || {};

  // for recently-read and replies
  const models = result.hits && result.hits.hits || result.docs || [];
  this.total = result.hits && result.hits.total || result.docs && result.docs.length || 0;

  this.facets = result.facets;

  const collection = models
    .map(data => {
      const model = data._source;
      if (!model) {
        return null;
      }
      return {
        type: data._type,
        date: model.date,
        userId: model.authorId,
        post: { ...model, snippet: model.body },
      };
    })
    .filter(x => !!x);

  return this.parseCollection(collection, options);
};

Activities.prototype.fetchWithDefaults = function(id, pageNumber) {
  return this
    .desc('pageNumber', pageNumber || 1)
    .desc('id', id || this.description.id)
    .fetch();
};

Activities.prototype.fetchGroup = function(groupCode, groupId, pageNumber) {
  return this
    .desc('filter', 'group-newsfeed')
    .fetchWithDefaults(groupId, pageNumber);
};

Activities.prototype.fetchUser = function(userId, pageNumber) {
  return this
    .desc('filter', 'user-activity')
    .fetchWithDefaults(userId, pageNumber);
};

Activities.prototype.fetchUserPublic = function(userId, pageNumber) {
  return this
    .desc('filter', 'user-activity-public')
    .fetchWithDefaults(userId, pageNumber);
};

module.exports = Activities;



// WEBPACK FOOTER //
// ./app/assets/js/collections/activities.js